import React from 'react';
import Appicon from '../coreComponent/Appicon';
import moment from 'moment';

export default class ReportDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={'verification-details'}>
        <div className={'verification-details-header'}>{'VERIFICATION DETAILS'}</div>
        {this.props.isIdMismatch === 'false' ? (
          <div className={'failed-verification-content'}>
            {this.props.error ? this.props.error : 'The check failed because of an ID mismatch'}
          </div>
        ) : null}
        <div>
          <div className={'verification-content-wrapper'}>
            {this.props.isFaceMatched === 'true' ? (
              <div className={'verification-content not-inline'}>
                <div className={'require-field'}>{'Face match:'}</div>
                <div className={'require-field-value margin-perfect'}>
                  <div
                    className={
                      this.props.details.faceMatch === 'Perfect' ? 'perfect value-bold' : 'barely'
                    }
                  >
                    {'Perfect'}
                  </div>
                  <div
                    className={
                      this.props.details.faceMatch === 'Almost' ? 'almost value-bold' : 'barely'
                    }
                  >
                    {'Almost'}
                  </div>
                  <div
                    className={
                      this.props.details.faceMatch === 'Barely' ? 'barely value-bold' : 'barely'
                    }
                  >
                    {'Barely'}
                  </div>
                  <div
                    className={
                      this.props.details.faceMatch === 'Failed' ? 'failed value-bold' : 'barely'
                    }
                  >
                    {'Failed'}
                  </div>
                </div>
              </div>
            ) : (
              <div className={'margin-top'}></div>
            )}

            {this.props.details.aadhaarNumber !== undefined &&
            this.props.details.aadhaarNumber !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.aadhaarNumber === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.aadhaarNumber === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Aadhaar number:'}</div>
                <div className={'require-field-value'}>
                  {[
                    this.props.details.aadhaarNumber.slice(0, 4),
                    '-',
                    this.props.details.aadhaarNumber.slice(4, 8),
                    '-',
                    this.props.details.aadhaarNumber.slice(8)
                  ]}
                </div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.panNumber !== undefined &&
            this.props.details.panNumber !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.panNumber === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.panNumber === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'PAN number:'}</div>
                <div className={'require-field-value'}>{this.props.details.panNumber}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.dlNumber !== undefined && this.props.details.dlNumber !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.dlNumber === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.dlNumber === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'DL number:'}</div>
                <div className={'require-field-value'}>{this.props.details.dlNumber}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.voterNumber !== undefined &&
            this.props.details.voterNumber !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.voterNumber === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.voterNumber === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Voter ID number:'}</div>
                <div className={'require-field-value'}>{this.props.details.voterNumber}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.name !== undefined && this.props.details.name !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.name === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.name === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Name:'}</div>
                <div className={'require-field-value'}>{this.props.details.name}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.dateOfBirth !== undefined &&
            this.props.details.dateOfBirth !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.dateOfBirth === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.dateOfBirth === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'DOB:'}</div>
                <div className={'require-field-value'}>
                  {moment(this.props.details.dateOfBirth).format('DD-MM-YYYY')}
                </div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.age !== undefined && this.props.details.age !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.age === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.age === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Age:'}</div>
                <div className={'require-field-value'}>{this.props.details.age}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.gender !== undefined && this.props.details.gender !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.gender === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.gender === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Gender:'}</div>
                <div className={'require-field-value'}>{this.props.details.gender}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.fathersName !== undefined &&
            this.props.details.fathersName !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.fathersName === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.fathersName === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Father’s Name:'}</div>
                <div className={'require-field-value'}>{this.props.details.fathersName}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.panType !== undefined && this.props.details.panType !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.panType === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.panType === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'PAN Type:'}</div>
                <div className={'require-field-value'}>{this.props.details.panType}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.district !== undefined && this.props.details.district !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.district === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.district === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'District:'}</div>
                <div className={'require-field-value'}>{this.props.details.district}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.state !== undefined && this.props.details.state !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.state === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.state === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'State:'}</div>
                <div className={'require-field-value'}>{this.props.details.state}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.rto !== undefined && this.props.details.rto !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.rto === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.rto === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'RTO:'}</div>
                <div className={'require-field-value'}>{this.props.details.rto}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.validFrom !== undefined &&
            this.props.details.validFrom !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.validFrom === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.validFrom === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Valid from:'}</div>
                <div className={'require-field-value'}>
                  {moment(this.props.details.validFrom).format('DD-MM-YYYY')}
                </div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.validTill !== undefined &&
            this.props.details.validTill !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.validTill === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.validTill === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Valid till:'}</div>
                <div className={'require-field-value'}>
                  {moment(this.props.details.validTill).format('DD-MM-YYYY')}
                </div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.vehicleClass !== undefined &&
            this.props.details.vehicleClass !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.vehicleClass === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.vehicleClass === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Vehicle Class:'}</div>
                <div className={'require-field-value'}>
                  {this.props.details.vehicleClass.replace(',', ', ')}
                </div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.parlimentaryConstituency !== undefined &&
            this.props.details.parlimentaryConstituency !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.parlimentaryConstituency === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.parlimentaryConstituency === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Parlimentary Constituency:'}</div>
                <div className={'require-field-value'}>
                  {this.props.details.parlimentaryConstituency}
                </div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.pollingStation !== undefined &&
            this.props.details.pollingStation !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.pollingStation === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.pollingStation === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>
                  {'Polling'}&nbsp;{'Station:'}
                </div>
                <div className={'require-field-value'}>{this.props.details.pollingStation}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.address !== undefined && this.props.details.address !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.address === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.address === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Address:'}</div>
                <div className={'require-field-value'}>{this.props.details.address}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.pincode !== undefined && this.props.details.pincode !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.pincode === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.pincode === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Pincode:'}</div>
                <div className={'require-field-value'}>{this.props.details.pincode}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.mobileNumber !== undefined &&
            this.props.details.mobileNumber !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.mobileNumber === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.mobileNumber === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Mobile Number:'}</div>
                <div className={'require-field-value'}>{this.props.details.mobileNumber}</div>
              </div>
            ) : (
              <div></div>
            )}

            {this.props.details.status !== undefined && this.props.details.status !== 'null' ? (
              <div className={'verification-content'}>
                {this.props.matchedInformation.status === 'null' ? (
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                ) : this.props.matchedInformation.status === 'true' ? (
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                ) : (
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                )}
                <div className={'require-field'}>{'Status:'}</div>
                <div
                  className={`require-field-value value-bold ${
                    this.props.details.status === 'Active' ? 'perfect' : 'failed'
                  }`}
                >
                  {this.props.details.status}
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <div className={'verification-footer'}>
            <div className={'heading'}>{'LEGEND'}</div>
            <div className={'footer-content'}>
              <div className={'symbols-wrapper'}>
                <div className={'symbols-content'}>
                  <div className={'mismatch-icon'}>
                    <Appicon iconCls={'mismatch'} />
                  </div>
                  <div className={'mismatch'}>{'Mismatch'}</div>
                </div>
                <div className={'symbols-content'}>
                  <div className={'circle-icon'}>
                    <Appicon iconCls={'na'} />
                  </div>
                  <div className={'na'}>{'N/A'}</div>
                </div>
                <div className={'symbols-content'}>
                  <div className={'match-icon'}>
                    <Appicon iconCls={'match'} />
                  </div>
                  <div className={'perfect'}>{'Information matched'}</div>
                </div>
              </div>
              <div className={'content'}>
                <div className={'info-icon'}>
                  <Appicon iconCls={'info'} />
                </div>
                {
                  'Facematch is our rating mechanism obtained by comparing the image in the identity document and the selfie photo uploaded.'
                }
              </div>
            </div>
          </div>{' '}
          <div className='svin-link'>
            <a href='https://in.springverify.com/' target='_blank'>
              SpringVerify
            </a>
          </div>
          <div className={'policy-link'}>
            <a href='https://www.springworks.in/privacy-policy/' target='_blank'>
              {'Privacy policy'}
            </a>
          </div>
          <div className='whatsapp-link'>
            <a
              href='https://api.whatsapp.com/send?phone=919019906003&text=SpringStart'
              target='_blank'
            >
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 256 256'>
                <path
                  fill='#00a884'
                  strokeMiterlimit='10'
                  d='M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.964 9.964 0 001.333 4.993L2 22l5.232-1.236a9.981 9.981 0 004.774 1.215h.004c5.505 0 9.985-4.48 9.988-9.985a9.923 9.923 0 00-2.922-7.066A9.923 9.923 0 0012.012 2zm-.002 2a7.95 7.95 0 015.652 2.342 7.93 7.93 0 012.336 5.65c-.002 4.404-3.584 7.987-7.99 7.987a7.999 7.999 0 01-3.817-.971l-.673-.367-.745.175-1.968.465.48-1.785.217-.8-.414-.72a7.98 7.98 0 01-1.067-3.992C4.023 7.582 7.607 4 12.01 4zM8.477 7.375a.917.917 0 00-.666.313c-.23.249-.875.852-.875 2.08 0 1.228.894 2.415 1.02 2.582.123.166 1.726 2.765 4.263 3.765 2.108.831 2.536.667 2.994.625.458-.04 1.477-.602 1.685-1.185.208-.583.209-1.085.147-1.188-.062-.104-.229-.166-.479-.29-.249-.126-1.476-.728-1.705-.811-.229-.083-.396-.125-.562.125-.166.25-.643.81-.79.976-.145.167-.29.19-.54.065-.25-.126-1.054-.39-2.008-1.24-.742-.662-1.243-1.477-1.389-1.727-.145-.25-.013-.386.112-.51.112-.112.248-.291.373-.437.124-.146.167-.25.25-.416.083-.166.04-.313-.022-.438s-.547-1.358-.77-1.852c-.186-.415-.384-.424-.562-.431-.145-.006-.31-.006-.476-.006z'
                  fontFamily='none'
                  fontSize='none'
                  fontWeight='none'
                  textAnchor='none'
                  transform='scale(10.66667)'
                ></path>
              </svg>
              9019906003
            </a>
          </div>
        </div>
      </div>
    );
  }
}

ReportDetails.defaultProps = {
  isIdMismatch: null,
  isFaceMatched: null,
  details: {},
  matchedInformation: {},
  isMisMatch: null,
  isInfoUnavailable: null,
  error: false
};
